<div class="user-avatar" [ngClass]="{'user-avatar--has-avatar': !!avatar}" [style.width.px]="size"
     [style.height.px]="size" [style.background-image]="avatarUrl">
    <p> {{initials}}</p>
    <i [ngClass]="icon" class="user-avatar--placeholder" [style.fontSize.px]="size/2" *ngIf="icon && !avatar"></i>
</div>
